module.exports = __webpack_public_path__ + "img/freelancer_thumbnail.d32149b8.jpg";